module.exports = __webpack_public_path__ + "static/img/overview.848e349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/overview.png
// module id = vgE2
// module chunks = 1